import { customAutoCompleteFilter, standardGridPageSize } from "../../../../Shared/GlobalVariables/filterVariables";

export default /*@ngInject*/ function ($uibModalInstance, helperService, RequestManagementOracleCloudService, selectedRole, existingAssignments) {

    const vm = this;

    vm.roleName = selectedRole.DisplayName;
    vm.selectedItems = [];
    vm.allSelectedCheckbox = false;
    vm.securityContexts = [];
    vm.selectedSecurityContext = null;
    vm.securityContextsByName = {};
    vm.loading = true;

    vm.updateSelection = updateSelection;
    vm.selectAll = selectAll;
    vm.changeSecurityContext = changeSecurityContext;
    vm.save = save;
    vm.cancel = cancel;

    activate();

    function activate() {
        RequestManagementOracleCloudService.getSecurityContexts()
            .then(function (response) {
                response.data.forEach(function (ctx) {
                    vm.securityContextsByName[ctx.Name] = ctx;
                });
                vm.securityContexts = Object.keys(vm.securityContextsByName).sort();
                if (vm.securityContexts.length > 0) {
                    vm.selectedSecurityContext = vm.securityContexts[0];
                }
                vm.loading = false;
                configureGrid();
            })
            .catch(function () {
                vm.loading = false;
                configureGrid();
            });
    }

    function configureGrid() {
        var columns = [
            { headerTemplate: '<label class="switch"><input type="checkbox" ng-model="sdamvm.allSelectedCheckbox" ng-change="sdamvm.selectAll()"><i></i></label>', template: "<label class='switch'><input type='checkbox' ng-model='dataItem.Selected' ng-change='sdamvm.updateSelection(dataItem)'><i></i></label>", width: 55, filterable: false },
            { field: "Name", title: "Security Context Value", filterable: customAutoCompleteFilter }
        ];

        vm.gridOptions = helperService.setMainGridOptions(columns, 400);

        vm.gridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            transport: {
                read: function (options) {
                    var ctx = vm.securityContextsByName[vm.selectedSecurityContext];
                    var values = ctx ? ctx.Values : [];
                    var data = values.map(function (v) {
                        return { Name: v.Value, SecurityContext: vm.selectedSecurityContext };
                    }).sort(function (a, b) { return a.Name.localeCompare(b.Name); });

                    var roleAssignments = existingAssignments.filter(function (a) {
                        return a.RoleCode === selectedRole.RoleName && a.SecurityContext === vm.selectedSecurityContext && a.Action !== 'Revoke';
                    });

                    var pendingSelections = vm.selectedItems.filter(function (s) {
                        return s.SecurityContext === vm.selectedSecurityContext;
                    });

                    data.forEach(function (item) {
                        item.Selected = roleAssignments.some(function (a) { return a.Name === item.Name; })
                            || pendingSelections.some(function (s) { return s.Name === item.Name; });
                    });

                    options.success(data);
                }
            }
        });
    }

    function changeSecurityContext() {
        vm.allSelectedCheckbox = false;
        vm.gridDataSource.read().then(function () {
            rebuildSelectedItems();
            checkAllSelected();
        });
    }

    function rebuildSelectedItems() {
        var currentGridSelected = vm.gridDataSource._data.filter(function (item) { return item.Selected; });

        var otherContextItems = vm.selectedItems.filter(function (item) {
            return item.SecurityContext !== vm.selectedSecurityContext;
        });

        vm.selectedItems = otherContextItems.concat(currentGridSelected);
    }

    function updateSelection(dataItem) {
        if (dataItem.Selected) {
            vm.selectedItems.push(dataItem);
        } else {
            vm.selectedItems = vm.selectedItems.filter(function (item) {
                return !(item.SecurityContext === dataItem.SecurityContext && item.Name === dataItem.Name);
            });
        }
        checkAllSelected();
    }

    function selectAll() {
        vm.gridDataSource._data.forEach(function (item) {
            item.Selected = vm.allSelectedCheckbox;
        });
        rebuildSelectedItems();
    }

    function checkAllSelected() {
        var view = vm.gridDataSource.view();
        vm.allSelectedCheckbox = view.length > 0 && view.toJSON().every(function (item) { return item.Selected; });
    }

    function save() {
        $uibModalInstance.close(vm.selectedItems);
    }

    function cancel() {
        $uibModalInstance.dismiss();
    }
}
